export const config = {
    REACT_APP_WEATHER_API_BASE_URL: "https://api.openweathermap.org",
    REACT_APP_WEATHER_API_KEY: "258155c6d27a767699dd8cf842540833",
};
